const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
};

/** GET /api/v1/admin/b2b/dashboard */
const getB2BDashboard = async () => {
  const response = await fetch(`${API_URL}/api/v1/admin/b2b/dashboard`, {
    headers: getAuthHeaders(),
  });
  return response.json();
};

/** GET /api/v1/admin/organizations */
const getOrganizations = async (filters = {}) => {
  const { is_active, search } = filters;
  const queryParams = new URLSearchParams();
  if (is_active === 'true' || is_active === 'false') {
    queryParams.append('is_active', is_active);
  }
  if (search) queryParams.append('search', search);

  const qs = queryParams.toString();
  const response = await fetch(
    `${API_URL}/api/v1/admin/organizations${qs ? `?${qs}` : ''}`,
    { headers: getAuthHeaders() }
  );
  return response.json();
};

/** GET /api/v1/admin/organizations/:id */
const getOrganizationById = async (organizationId) => {
  const response = await fetch(
    `${API_URL}/api/v1/admin/organizations/${organizationId}`,
    { headers: getAuthHeaders() }
  );
  return response.json();
};

/** POST /api/v1/admin/organizations */
const createOrganization = async (payload) => {
  const response = await fetch(`${API_URL}/api/v1/admin/organizations`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });
  return response.json();
};

/** PATCH /api/v1/admin/organizations/:id */
const updateOrganization = async (organizationId, payload) => {
  const response = await fetch(
    `${API_URL}/api/v1/admin/organizations/${organizationId}`,
    {
      method: 'PATCH',
      headers: getAuthHeaders(),
      body: JSON.stringify(payload),
    }
  );
  return response.json();
};

export {
  getB2BDashboard,
  getOrganizations,
  getOrganizationById,
  createOrganization,
  updateOrganization,
};
